export default {
  setExcelCheckBoxesNames({ commit }, payload) {
    commit("ExcelCheckBoxesNamesMut", payload);
  },
};
